import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import TextField from 'components/text-field';
import MyModal from '../modal';
import { Close } from '@mui/icons-material';
import { useUpdateURLParams } from 'common-hooks/update-query-params-hooks';

export default function CreateNewDraftModal({
  open,
  setOpen,
  createDraft,
  edit,
  updateDraft,
  worksheetCollectionId,
  initialDraftName,
  quickPanelHandleClose,
  redirect,
}) {
  const { updateURLParams } = useUpdateURLParams();

  const handleClose = () => {
    setOpen(false);
  };

  const [name, setName] = useState('');
  const [error, setError] = useState({ status: false, message: '' });

  useEffect(() => {
    if (initialDraftName) setName(initialDraftName);
    else setName('New Draft');
  }, [initialDraftName]);

  function validateAndSubmit() {
    if (name === '') {
      setError({ status: true, message: 'Draft name cannot be empty.' });
    } else if (name === initialDraftName) {
      setError({
        status: true,
        message: 'Draft name cannot be the same as before.',
      });
    } else {
      if (edit) updateDraft(name, worksheetCollectionId);
      else {
        redirect
          ? createDraft(name, quickPanelHandleClose, true)
          : createDraft(name, quickPanelHandleClose, false);
      }
      setName('');
      handleClose();
    }
  }

  function resetError() {
    setError({ status: false, message: '' });
  }
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      validateAndSubmit();
    }
  };
  return (
    <MyModal open={open} setOpen={setOpen} size='large' showCloseIcon>
      <Stack
        spacing={2}
        justifyContent='center'
        alignItems='center'
        sx={{ position: 'relative' }}
      >
        <IconButton
          sx={{ position: 'absolute', top: 0, right: 0 }}
          onClick={(e) => {
            e.preventDefault();
            setName('');
            handleClose();
          }}
        >
          <Close />
        </IconButton>
        <Typography variant='h1'>
          {edit ? 'Update Draft' : 'New Draft'}
        </Typography>
        <TextField
          autoFocus
          onFocus={(e) => {
            e.target.select();
          }}
          label='Draft Name'
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            resetError();
          }}
          onKeyPress={handleKeyPress}
          error={error.status}
          helperText={error.message}
          sx={{ width: '360px' }}
        />

        <Stack direction='row' spacing={2}>
          <Button
            variant='outlined'
            color='secondary'
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            onClick={(e) => {
              e.preventDefault();
              updateURLParams({ resetCatalog: true });
              validateAndSubmit();
            }}
          >
            {edit ? 'Save Changes' : 'Create'}
          </Button>
        </Stack>
      </Stack>
    </MyModal>
  );
}

CreateNewDraftModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  createDraft: PropTypes.func,
  updateDraft: PropTypes.func,
  edit: PropTypes.bool,
  worksheetCollectionId: PropTypes.string.isRequired,
  initialDraftName: PropTypes.string,
  quickPanelHandleClose: PropTypes.func,
  redirect: PropTypes.bool,
};

CreateNewDraftModal.defaultProps = {
  edit: false,
  worksheetCollectionId: '',
  createDraft: () => {},
  updateDraft: () => {},
  initialDraftName: '',
  quickPanelHandleClose: () => {},
  redirect: false,
};
